import React from 'react'
import PropTypes from 'prop-types'

/**
 * CustomVideo component provides a customizable video player.
 * It allows you to specify style properties and control visibility.
 * The component renders a video element with an optional set of controls.
 *
 * @component
 * @param {Object} props - The component props.
 * @param {Object} props.styleProps - Additional styles to apply to the video element.
 * @param {boolean} [props.showControls=true] - Determines whether to display video controls.
 * @param {...Object} props - Other props are passed to the video source element.
 * @returns {JSX.Element} The rendered CustomVideo component.
 */
const CustomVideo = ({ styleProps, showControls = true, ...props }) => {
	return (
		<video {...styleProps} controls={showControls} className="we-custom-video">
			<source {...props} />
		</video>
	)
}

export default CustomVideo

CustomVideo.propTypes = {
	styleProps: PropTypes.object,
	showControls: PropTypes.bool
}